import './AboutPage.css';

function SupportPage() {
  return (
    <div className="about-page-white">
      <div className="about-container">
        <section className="about-section-white">
          <h2>Support</h2>
          <p>
            We're here to help! If you have any questions, concerns, or need assistance with PetPalette, 
            please reach out to our support team.
          </p>
          <p>
            <strong>Email:</strong> support@petpaletteusa.com
          </p>
          <p>
            For urgent matters, please include "URGENT" in the subject line of your email. 
            We typically respond within 24-48 hours.
          </p>
        </section>
      </div>
    </div>
  );
}

export default SupportPage;
